import toast from "react-hot-toast";
import LogoutCallback from "./logout";

const ErrorAlert = (error, navigation) => {
  const toastOptions = {
    position: "top-center",
    // autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  const status = error?.response?.status;
  const data = error?.response?.data;

  switch (status) {
    case 400:
    case 404: {
      const nestedErrors = data?.data?.errors; // handle your structure
      const flatErrors = data?.errors; // other fallback formats

      if (Array.isArray(nestedErrors) && nestedErrors.length > 0) {
        // ✅ Combine all messages into one
        const combinedMessage = nestedErrors
          .map((err) => `• Row ${err.no}: ${err.errorMsg}`)
          .join("\n");

        toast.error(combinedMessage, {
          ...toastOptions,
          duration: 8000,
          style: {
            whiteSpace: "pre-line", // ✅ allows multiline display
            maxWidth: "500px",
          },
        });
      } else if (Array.isArray(flatErrors) && flatErrors.length > 0) {
        const combinedMessage = flatErrors.map((msg) => `• ${msg}`).join("\n");
        toast.error(combinedMessage, {
          ...toastOptions,
          style: { whiteSpace: "pre-line" },
        });
      } else if (data?.errors && Object.keys(data.errors).length > 0) {
        const combinedMessage = Object.entries(data.errors)
          .map(([key, messages]) =>
            Array.isArray(messages)
              ? messages.map((msg) => `• ${key}: ${msg}`).join("\n")
              : `• ${key}: ${messages}`
          )
          .join("\n");

        toast.error(combinedMessage, {
          ...toastOptions,
          style: { whiteSpace: "pre-line" },
        });
      } else if (data?.message?.error?.message) {
        toast.error(data.message.error.message, toastOptions);
      } else if (data?.error?.message) {
        toast.error(data.error.message, toastOptions);
      } else if (data?.errorMesage) {
        toast.error(data.errorMesage, toastOptions);
      } else if (Array.isArray(data) && data.length > 0) {
        const combinedMessage = data.map((msg) => `• ${msg}`).join("\n");
        toast.error(combinedMessage, {
          ...toastOptions,
          style: { whiteSpace: "pre-line" },
        });
      } else if (typeof data === "string" && data !== "") {
        toast.error(data, toastOptions);
      } else {
        toast.error("Something went wrong. Please try again.", toastOptions);
      }
      break;
    }


    case 401:
      if (typeof LogoutCallback === "function") {
        LogoutCallback(navigation);
      }
      toast.error(
        "You’ve been logged out due to inactivity. Please sign in again to continue.",
        toastOptions
      );
      break;

    case 403:
      toast.error("Access denied. You don’t have permission.", toastOptions);
      break;

    case 500:
      toast.error("Internal server error. Please try again later.", toastOptions);
      break;

    default:
      toast.error("An unexpected error occurred. Please try again.", toastOptions);
      break;
  }

  // Handle cases with no response
  if (!status) {
    if (error.message) {
      toast.error(error.message, toastOptions);
    } else {
      toast.error("An error occurred without a response", toastOptions);
    }
  }

  return null;
};


export default ErrorAlert;
